/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GuarantorRequest } from './GuarantorRequest';

/**
 * Information that needs to be provided in order for a user to store/update a pharmacy insurance details.
 */
export type PharmacyInsuranceRequest = {
    /**
     * CardHolder ID of an Insurance or a Manufacturer Coupon.
     */
    cardHolderId: string;
    /**
     * Status of current Insurance/Coupon.
     */
    status: PharmacyInsuranceRequest.status;
    /**
     * The date when a insurance is effective from.
     */
    effectiveStartDate?: string;
    /**
     * The date when this insurance is effective until.
     */
    effectiveEndDate?: string;
    /**
     * The ID of uploaded file which is front of the card.
     */
    frontPhotoFileId?: string;
    /**
     * The ID of uploaded file which is back of the card.
     */
    backPhotoFileId?: string;
    /**
     * RX Group ID of an Insurance or a Manufacturer Coupon.
     */
    rxGrp?: string;
    /**
     * Bank Identification Number of a Pharmacy Insurance or a Manufacturer Coupon.
     */
    rxBin: string;
    /**
     * Processor Control Number of a Pharmacy Insurance or a Manufacturer Coupon.
     */
    rxPcn?: string;
    /**
     * The name of the insurance plan.
     */
    planName?: string;
    /**
     * Flag - if an insurance is a primary.
     */
    isPrimary: boolean;
    /**
     * Relationship to a cardholder.
     */
    primaryPlanOwner: PharmacyInsuranceRequest.primaryPlanOwner;
    /**
     * The id of partner.
     */
    partnerId?: string;
    guarantor?: GuarantorRequest;
};

export namespace PharmacyInsuranceRequest {

    /**
     * Status of current Insurance/Coupon.
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }

    /**
     * Relationship to a cardholder.
     */
    export enum primaryPlanOwner {
        SELF = 'SELF',
        SPOUSE = 'SPOUSE',
        PARENT = 'PARENT',
        OTHER = 'OTHER',
        UNKNOWN = 'UNKNOWN',
    }


}

